import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconIntercom12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconIntercom12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10 11.706 7.6 11H2.5A1.5 1.5 0 0 1 1 9.5v-7A1.5 1.5 0 0 1 2.5 1h7A1.5 1.5 0 0 1 11 2.5V12zM10 2.5v8.164l-2.118-.623L7.744 10H2.5a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5M3.84 7.301a.5.5 0 0 0-.604.797L3.54 7.7c-.303.398-.302.399-.302.399l.002.001.005.004.013.01.047.033q.06.041.166.11c.141.088.344.204.594.32.497.23 1.206.47 2.013.47.808 0 1.516-.24 2.013-.47a5.4 5.4 0 0 0 .807-.463l.013-.01.005-.004h.001l.001-.001-.301-.399.302.398a.5.5 0 0 0-.604-.797l-.005.004-.03.02q-.042.03-.125.083c-.113.07-.278.166-.484.261-.417.193-.978.377-1.593.377s-1.176-.184-1.593-.377a4.5 4.5 0 0 1-.638-.364zm0 0-.3.399c.302-.398.302-.399.301-.399"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconIntercom12);
